import { z } from 'zod';
import type { AnsweredTrial, CommonsStats, ConfigResponse, Fingerprint } from './types';

const configSchema = z.object({
  turnstileSiteKey: z.string(),
  turnstileMode: z.enum(['production', 'test'])
});

const commonsSchema = z.object({
  savedCurves: z.number(),
  savedChoices: z.number(),
  meanK: z.number().nullable(),
  meanAuc: z.number().nullable(),
  meanPresentBias: z.number().nullable(),
  meanConsistency: z.number().nullable(),
  bins: z.array(z.object({ delayDays: z.number(), n: z.number(), meanValue: z.number(), sdValue: z.number() })),
  buckets: z.array(z.object({
    bucket: z.string(),
    n: z.number(),
    meanK: z.number(),
    meanAuc: z.number(),
    meanPresentBias: z.number(),
    meanConsistency: z.number()
  }))
});

export async function loadConfig(): Promise<ConfigResponse> {
  const res = await fetch('/api/config', { headers: { accept: 'application/json' } });
  if (!res.ok) throw new Error('Config unavailable');
  return configSchema.parse(await res.json());
}

export async function loadCommons(): Promise<CommonsStats> {
  const res = await fetch('/api/stats', { headers: { accept: 'application/json' } });
  if (!res.ok) throw new Error('Commons unavailable');
  return commonsSchema.parse(await res.json());
}

export async function submitFingerprint(payload: {
  deviceKey: string;
  turnstileToken: string;
  consentText: string;
  consentVersion: string;
  startedAt: string;
  answers: AnsweredTrial[];
  fingerprint: Fingerprint;
}) {
  const res = await fetch('/api/finish', {
    method: 'POST',
    headers: { 'content-type': 'application/json', accept: 'application/json' },
    body: JSON.stringify(payload)
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.error ?? 'Submission failed');
  return body as { ok: true; sessionId: string; participantId: string; stats: CommonsStats };
}
